module.exports = __webpack_public_path__ + "static/img/purchase_apps_banner.f4e5db1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/purchase_apps_banner.png
// module id = RN/n
// module chunks = 134